export const LimitTypes: Record<string, number> = {
	Deposit: 1,
	Spending: 1,
};
